import { ListInvoices } from './list-invoices';

export default ListInvoices;
